import tw from 'tailwind-styled-components';
import styled from "styled-components";
import { ReactNode } from 'react';

export const ContainerListing = tw.div`
  w-11/12
  mx-auto
  max-w-3xl
  border-b
  border-corporate-blue
  py-10
  space-y-4
`;

export const ContainerSubline = styled.div<{
  children?: ReactNode;
}>`
  width: 100%;
  margin: 0 auto;
  max-width: 731px;
  @media screen and (min-width: 768px) {
    padding-top: 92px;
  }
  & > * {
    text-align: center;
    color: #292b29;
    text-transform: uppercase;
  }
`;
